'use client';

import { c as _c } from "react/compiler-runtime";
import { WelloChat } from '@wello-client/chat-sdk/react';
import { usePathname } from 'next/navigation';
import { ENV } from '@/constants';
import { useAccessToken } from '@/hooks/useAccessToken';
import { useAuthStore } from '@/stores/AuthStore';
import { isCsChatPath } from './csChatPath';
export const CsChat = () => {
  const $ = _c(2);
  const pathname = usePathname();
  const isLogin = useAuthStore(_temp);
  const {
    accessToken
  } = useAccessToken();
  const isAuthSettled = isLogin === false || isLogin === true && !!accessToken;
  if (!isCsChatPath(pathname) || !isAuthSettled) {
    return null;
  }
  const t0 = isLogin ? accessToken : null;
  let t1;
  if ($[0] !== t0) {
    t1 = <WelloChat memberToken={t0} src={ENV.NEXT_PUBLIC_CHAT_LOADER_URL} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(state) {
  return state.isLogin;
}